module.exports = __webpack_public_path__ + "img/access-website.1670fa45.png";